module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAzNiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjE4NDI0IDE2Ljk0MjVMMi42Nzk1NyAxNC4yNUgzNS40NDc4VjEyLjc1SDIuNjc5NTdMNS4xODQyNCAxMC4wNTc1TDQuMTk3NzYgOUwwIDEzLjVMNC4xOTc3NiAxOEw1LjE4NDI0IDE2Ljk0MjVaTTM1LjQ0NzggNC41TDMxLjI1IDBMMzAuMjYzNSAxLjA1NzVMMzIuNzY4MiAzLjc1SDBWNS4yNUgzMi43NjgyTDMwLjI2MzUgNy45NDI1TDMxLjI1IDlMMzUuNDQ3OCA0LjVaIiBmaWxsPSIjOUVBN0I2Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrows-horizontal.svg
// module id = 215
// module chunks = 1